// extracted by mini-css-extract-plugin
module.exports = {"brand-list":"brand-list_brand-list__2CP1z","brarnd-item":"brand-list_brarnd-item__dIoXU"};